import React from "react";

export const Contact = (props) => {
  return (
    <div>
      {/* Footer Simples */}
      <div id="footer" className="footer">
        <div className="container">
          <p>&copy; 2025 CoffeeIn Club</p>
        </div>
      </div>
      
      <style jsx>{`
        .footer {
          background: #2c2c2c;
          color: white;
          padding: 15px 0;
          text-align: center;
          font-size: 12px;
        }
        
        .footer p {
          margin: 0;
          color: #ccc;
        }
      `}</style>
    </div>
  );
};
